import { Component, Input } from '@angular/core';
import { link, LinkProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-link',
  template: `<span kiteText tabIndex="0" [size]="size === 'xs' ? 'sm' : 'md'" [ngClass]="link"
    ><span><ng-content></ng-content></span
    ><kite-icon fill="black" name="link-blank" [size]="size === 'xs' ? 'sm' : 'md'"></kite-icon
  ></span> `,
})
export class LinkComponent implements LinkProps {
  /**
   * Agrega subrayado al link
   */
  @Input() underlined: LinkProps['underlined'];
  /**
   * Estado desabilitado del botón
   */
  @Input() isDisabled: LinkProps['isDisabled'];
  /**
   * Si el link es externo agrega un ícono para identificarlo
   */
  @Input() isExternal: LinkProps['isExternal'];

  /**
   * Tamaño del link
   */
  @Input() size: LinkProps['size'];

  /**
   * Variante dark del link
   */
  @Input() dark: LinkProps['dark'];

  /**
   * CSS del componente
   */
  @Input() css: LinkProps['css'];

  public get link(): string[] {
    return [
      link({
        underlined: !!(this.underlined || this.isExternal),
        isDisabled: this.isDisabled,
        isExternal: this.isExternal,
        size: this.size,
        dark: this.dark,
        css: this.css,
      }).className,
    ];
  }
}
